const WEBHOOKS = ({ permissionIsEnabled, routeName }) => {
  return {
    key: 'webhooks',
    routeName: 'webhooks',
    label: 'sidemenu.webhooks',
    showSection: permissionIsEnabled('webhook:search'),
    active: routeName === 'webhooks' || routeName === 'webhooksDetail'
  }
}

export default WEBHOOKS
